import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { initSentry } from "@/lib/sentry";
import { seedDevAuth } from "@/lib/devAuth"; // TEMP dev-only auth bypass — do not commit

initSentry();
seedDevAuth(); // TEMP dev-only auth bypass — do not commit

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
